/**
 * Заглушка «показывать нечего» для `whenEmpty`. Нужна там, где пустое значение —
 * не пробел в данных, а обычное состояние: подпись под именем, скобки с должностью,
 * строка с иконкой. Плашка «Не указано» в таких местах только шумит.
 */
export function Nothing() {
  return null;
}
